import React, { useEffect, useState } from "react";
import {
  FloatButton,
  Drawer,
  Select,
  DatePicker,
  Button,
  Skeleton,
  ConfigProvider,
} from "antd";
import RawGrid from "../../../../../../Elements/Grid/Grid";

import {
  formatDateTime,
  generatedISOFormatDateString,
  roundOffValue,
  roundToTwoDecimalPlaces,
} from "../../../../../../../Utils/DateConverstion";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import CustomDrawer from "../../../../../../Elements/CustomDrawer";
// import TreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import TreeSelectCustom from "../../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import ExportToExel from "./Export";

import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import ExportToExcel from "../../../../../../Elements/Grid/Export";
import { useSelector } from "react-redux";
import TableComponent from "../../../../../../Elements/Grid/TableComponent";
import {
  FilterOutlined,
   } from "@ant-design/icons";
import Empty from "../../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import SteamTreeSelectCustomWithSelectAll from "../../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";

// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear); 
dayjs.extend(customParseFormat);
 
 
const RawDataElectrical = () => { 
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1);
  const [converterGroupId, setConverterGroupId] = useState(1);
  const [report, setReport] = useState([]); 
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const defaultParameters = ['kWhImport','KWT','IAVG','VLLAvg'];
  const [selectedValues, setSelectedValues] = useState(['KWT']); 
  // const [fromDateObj, setFromDateObj] = useState(null);
  // const [fromDateString, setFromDateString] = useState();
  // const [toDateObj, setToDateObj] = useState(null);
  // const [toDateString, setToDateString] = useState();
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [chartSkip, setChartSkip] = useState();
  const [chartInput, setChartInput] = useState();
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [datesError, setDatesError] = useState(null);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  // const [value, setValue] = useState([null,null]);
  const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss"));
    const [fromDateString, setFromDateString] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")][0]);
    const [toDateObj, setToDateObj] = useState(dayjs().format("YYYY-MM-DD HH:mm:ss"));
    const [toDateString, setToDateString] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")][1]);
   const [value, setValue] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")]);
  const [selectedHeader,setSelectedHeader]= useState([])
 
  const [steamRawData, setsteamRawData] = useState([]);
  const [parameter, setParameter] = useState([]);
  const [rawData,setRawData]= useState([])
  const [defaultLoad,setDefaultLoad]=  useState(true)
  const [excelFromDate,setExcelFromDate]=useState()
  const [excelToDate,setExcelToDate]=useState()

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color) 
  const [loadings, setLoadings] = useState(true);
  // const simulateLoading = (setLoadings) => {
  //   setLoadings(true);
  //   setTimeout(() => {
  //     setLoadings(false);
  //   }, 2000); // 2 seconds
  // };
  // useEffect(() => {
  //   simulateLoading(setLoadings);
  // }, []);

  let formattedFromDate;
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if(res&&res.length>0){
          
        setflowSectionResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if(res&&res.length>0){
          
        setParameter(res);
      }
    });
  }, []);
  useEffect(() => {
    if(sectionId==1){
         makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if(res&&res.length>0){
          
        setgetFlowConverterResData(res);
      }
    });
    }

    if(sectionId==2){
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
      }).then((res) => {
        // //console.log(res);
        if(res&&res.length>0){
            
          setflowGroupDetailsResData(res);
        }
      }); 
    }





  }, [sectionId]);

  useEffect(() => {
    // //console.log(converterGroupId);
    if(converterGroupId&&sectionId==1){
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        // //console.log(res);
        if(res&&res.length>0){
               if (defaultLoad) {
            const firstFiveMeters = res
              .slice(0, 5)
              .map((meter) => meter.meterid);

            //console.log(res.map((meter) => meter.meterid));
            //console.log(firstFiveMeters);
            setSelectedMeterIds(firstFiveMeters);
            localStorage.setItem("PlotMeterIds", firstFiveMeters);
            setDefaultLoad(false);
          }
          //   if(defaultLoad){
          // setSelectedMeterIds(res.map(meter => meter.meterid))
          // localStorage.setItem("PlotMeterIds", res.map(meter => meter.meterid));
          // setDefaultLoad(false)
          //   }
          setnsGetFlowConverterResData(res);
        }
      });
    }
    if(converterGroupId&&sectionId==2){
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
      }).then((res) => {
        // //console.log(res);
        if(res&&res.length>0){
            
          setgetFlowSteamGroupMeterResData(res);
        }
      });
    }
  }, [converterGroupId]);

//         function transformToAgGridRows(data, parameterKeys = ["IAVG"]) {
//   const rowsMap = new Map();
//   const columnSet = new Set();

//   data.forEach(item => {
//     const timestamp = item.CreatedOn;
//     const meterName = item.METERNAME;

//     if (!rowsMap.has(timestamp)) {
//       rowsMap.set(timestamp, { CreatedOn: timestamp });
//     }

//     const row = rowsMap.get(timestamp);

//     parameterKeys.forEach(param => {
//       const columnKey = `${meterName}-${param}`;
//       columnSet.add(columnKey);
//       row[columnKey] = item[param] !== undefined ? item[param] : 0;
//     });
//   });

//   // Fill missing values as 0 for consistency
//   const columnHeaders = Array.from(columnSet);
//   const finalRows = Array.from(rowsMap.values()).map(row => {
//     columnHeaders.forEach(col => {
//       if (!(col in row)) row[col] = 0;
//     });
//     return row;
//   });

//   return {
//     rowData: finalRows,
//     columnDefs: [
//       { headerName: "Timestamp", field: "CreatedOn", pinned: 'left', minWidth: 150 },
//       ...columnHeaders.map(col => ({
//         headerName: col,
//         field: col,
//         minWidth: 120,
//       }))
//     ]
//   };
// }
// const result = transformToAgGridRows(data);
// //console.log(result.rowData);     // Data for AgGrid
// //console.log(result.columnDefs)


function transformForAgGrid(data) {
  const grouped = new Map();

  for (const item of data) {
    const timestamp = item.CreatedOn;
    const formattedDate = new Date(timestamp).toLocaleString('en-US');

    if (!grouped.has(timestamp)) {
      grouped.set(timestamp, { date: formattedDate });
    }

    const row = grouped.get(timestamp);

    for (const key in item) {
      if (!['SiteName', 'MeterId', 'CreatedOn', 'METERNAME'].includes(key)) {
        const columnKey = `${item.METERNAME}-${key}`;
        row[columnKey] = item[key];
      }
    }

    grouped.set(timestamp, row);
  }

  return Array.from(grouped.values());
}



  const getResponse = (inputData) => {
    //console.log(inputData);
setLoadings(true)
    if(inputData&&inputData.SectionID&& inputData.ConverterorGroupID&&inputData.MeterIds&&inputData.Parameters){
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_RAWDATA}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}`,
      }).then((res) => { 
        //console.log(res); 
        if(res&&res.length>0){
          setsteamRawData(res);
          const test =transformForAgGrid(res)
          //console.log(test)
          setRawData(test)
          setLoadings(false)
        }else{
          setsteamRawData([]);
          setLoadings(false)
        }  
      });

    }

  };


  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setConverterGroupId()
    setSelectedMeterIds([]);
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds([]);
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    // //console.log(selectedValues)
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };

  const onChangeFromDate = ( dateString) => {
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = ( dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const setChartInputData = () => {
    // const [date, time] =  fromDateString?.split("T")
    // const [toDateSplit, toTimeSplit] =toDateString?.split("T")
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);
//     //console.log(fromDateString)
//     //console.log(toDateString)
//     //console.log(formattedFromDate)
// //console.log(formattedToDate)
    setExcelFromDate(formatDateTime(formattedFromDate))
    setExcelToDate(formatDateTime(formattedToDate))

    const ids = selectedMeterIds?.map((id) => id).join(",");
    const para = selectedValues?.map((id) => id).join(",");
    //console.log(ids)
    const inputData = {
      SectionID: Number(sectionId) || 0,
      ConverterorGroupID: Number(converterGroupId) || 2,
      MeterIds: ids || 0,
      Parameters: para || 0,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
    //console.log(inputData)
    getResponse(inputData);
    setSelectedHeader(selectedMeters())
    
  };
 useEffect(() => {
    setChartInputData();
  }, [defaultLoad]);
  
  useEffect(() => {
    setChartInputData();
  }, []);


    useEffect(() => {
      setChartSkip(false);
      updateChart();
    }, [chartInput, steamRawData]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    let hasError = false;

  // Section validation
  if (!sectionId) {
    setSectionError("Please select a section.");
    hasError = true;
  } else {
    setSectionError("");
  }

  // Converter/Group validation
  if (!converterGroupId) {
    setConverterError("Please select a converter/group.");
    hasError = true;
  } else {
    setConverterError("");
  }

  // Meter validation
  if (!selectedMeterIds || selectedMeterIds.length === 0) {
    setMeterError("Please select at least one meter.");
    hasError = true;
  } else {
    setMeterError("");
  }

  // Parameter validation
  if (!selectedValues || selectedValues.length === 0) {
    setParaError("Please select at least one parameter.");
    hasError = true;
  } else {
    setParaError("");
  }

  // Date range validation
  if (!value || value.length !== 2 || !value[0] || !value[1]) {
    setFromDateError("Please select a valid date range.");
    hasError = true;
  } else {
    setFromDateError("");
  }



  // //console.log("Submitting data with values:", {
  //   sectionId,
  //   converterGroupId,
  //   selectedMeterIds,
  //   selectedValues,
  //   dateRange: value,
  // });
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");
 if(fromDateError||toDateError){
      setDatesError('Please select a date range')
    }
    //console.log(setSelectedMeterIds)

    setSectionError(sectionError);
    setConverterError(converterError); 
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError
       &&
      !fromDateError &&
      !toDateError&&
      !hasError&&
      !datesError
    ) {
      onClose();
      setChartInputData();
    }
  };
  const findMaxMeter = (array) => {
    let maxMeter = array[0]?.name;
    let maxLength = array[0]?.data?.length;
  
    array.forEach((arr) => {
      const currentLength = arr.data.length;
      if (currentLength > maxLength) {
        maxLength = currentLength;
        maxMeter = arr.name;
      }
    });
    return maxMeter;
  };

  
  const maxDates = (name, data) => {
    const modifiedString = name.replace(/-(VR|VY|VB|F|VRY|VYB|VBR|VLLAvg|IR|IY|IB|IAVG|Vunb|Iunb|KWT|KVAT|KVART|PFT|PFR|PFY|PFB|KWR|KWY|KWB|KVA_R|KVA_Y|KVA_B|KVAR_R|KVAR_Y|KVAR_B|KWD|KVAD|KWHTotal|kWhImport|KWHEXPORT|kVAh|kVArhTotal|kVArhinductive|KVARHCAPACITIVE|V_THDAvg|V_THDR|V_THDY|V_THDB|I_THDAvg|I_THDR|I_THDY|I_THDB)$/, "");
    const filteredData = data.filter((d) => d.METERNAME === modifiedString);
    // //console.log(data)
  
    if (filteredData.length === 0) {
      return [];
    }
  
    return filteredData.map((d) => d.CreatedOn);
  };
  
  const bindData = (datesArray, data) => {
    const resultArray = [];
    //console.log(datesArray)
    //console.log(data)
  
    datesArray.forEach((date, index) => {
      const dataObject = { date: new Date(date).toLocaleString() };
  
      data.forEach((item) => {
        dataObject[item.name] = item.data[index]  ? item.data[index] : 0;
      });
  
      resultArray.push(dataObject);
    });
  
    return resultArray;
  };
  
  const updateChart = async () => {
    try {
      const selectedMeterData = steamRawData
        .filter((item) => selectedMeterIds.map((id) => Number(id)).includes(item.MeterId))
        .sort((a, b) => new Date(a.CreatedOn) - new Date(b.CreatedOn));
        // //console.log(selectedMeterData);
        // //console.log(selectedMeterIds)
  
      

      const transformData = (property, meterName) => {
        // //console.log(property)
        // //console.log(meterName)
        // //console.log(selectedMeterData)
        // Filter the data for the given meterName (case-insensitive)
        const data = selectedMeterData
          .filter((item) => item.METERNAME.toLowerCase() === meterName.toLowerCase()) // Case-insensitive comparison
          .map((item) => {
            // Normalize property to lowercase for comparison with item keys
            const normalizedProperty = Object.keys(item).find((key) => key.toLowerCase() === property.toLowerCase());
            // //console.log(normalizedProperty)
            // //console.log(item)
            // //console.log(item[normalizedProperty])
      
            // If a matching property is found, return its value, otherwise return null
            return normalizedProperty ? item[normalizedProperty] : null;
          });
      
        return {
          name: `${meterName}-${property}`, // Concatenate meterName and property
          data
        };
      };
      
      // [
      //   "VR", "VY", "VB", "F", "VRY", "VYB", "VBR", "VLLAvg", "IR", "IY", 
      //   "IB", "IAVG", "Vunb", "Iunb", "KWT", "KVAT", "KVART", "PFT", "PFR", 
      //   "PFY", "PFB", "KWR", "KWY", "KWB", "KVA_R", "KVA_Y", "KVA_B", 
      //   "KVAR_R", "KVAR_Y", "KVAR_B", "KWD", "KVAD", "KWHTotal", "kWhImport", 
      //   "KWHEXPORT", "kVAh", "kVArhTotal", "kVArhinductive", "KVARHCAPACITIVE", 
      //   "V_THDAvg", "V_THDR", "V_THDY", "V_THDB", "I_THDAvg", "I_THDR", 
      //   "I_THDY", "I_THDB"
      // ]
      
  
      const properties =['KWHTotal', 'kWhImport','KWHEXPORT', 'kVAh', 'kVArhTotal', 'kVArhinductive', 'KVARHCAPACITIVE','VR', 'VY', 'VB', 'F', 'VRY', 'VYB', 'VBR', 'VLLAvg', 'IR', 'IY','IB', 'IAVG', 'Vunb', 'Iunb', 'KWT', 'KVAT', 'KVART', 'PFT', 'PFR','PFY', 'PFB', 'KWR', 'KWY', 'KWB', 'KVA_R', 'KVA_Y', 'KVA_B','KVAR_R', 'KVAR_Y', 'KVAR_B', 'KWD', 'KVAD', 'V_THDAvg', 'V_THDR', 'V_THDY', 'V_THDB', 'I_THDAvg', 'I_THDR', 'I_THDY', 'I_THDB'
      ].filter((value) => selectedValues.includes(value));
  
      const seriesData = [];
      selectedMeterIds.forEach((id) => {
        const meterName =
          sectionId === 1
            ? nsGetFlowConverterList.find((item) => Number(item.meterid) === Number(id))?.metername
            : getFlowSteamGroupMeterList.find((item) => item.meterid === Number(id))?.metername;
            // //console.log(meterName)
  
        properties.forEach((property) => {
          seriesData.push(transformData(property, meterName));
        });
      });
      // //console.log(seriesData)
  
      const maxCountMeter = findMaxMeter(seriesData);
      const maxDatesArray = maxDates(maxCountMeter, selectedMeterData);
      const tableData = bindData(maxDatesArray, seriesData);
  
      // Transform tableData for ag-Grid format
      //console.log(tableData)
      // //console.log(agGridRows) 
      const agGridRows = [];
      tableData.forEach((rowData) => {
        const existingRow = agGridRows.find((row) => row.date === rowData.date);
  
        if (existingRow) {
          Object.assign(existingRow, rowData);
        } else {
          agGridRows.push(rowData);
        }
      });

  
      //console.log(agGridRows);
      setReport(agGridRows);
      selectedMeterIds()
    } catch (err) {
      //console.log(err);
    }
  };
 
  const selectedMeters = () => {
    const parameterList = [
      { parameterid: 1, parametername: "VR" },
      { parameterid: 2, parametername: "VY" },
      { parameterid: 3, parametername: "VB" },
      { parameterid: 4, parametername: "F" },
      { parameterid: 5, parametername: "VRY" },
      { parameterid: 6, parametername: "VYB" },
      { parameterid: 7, parametername: "VBR" },
      { parameterid: 8, parametername: "VLLAvg" },
      { parameterid: 9, parametername: "IR" },
      { parameterid: 10, parametername: "IY" },
      { parameterid: 11, parametername: "IB" },
      { parameterid: 12, parametername: "IAVG" },
      { parameterid: 13, parametername: "Vunb" },
      { parameterid: 14, parametername: "Iunb" },
      { parameterid: 15, parametername: "KWT" },
      { parameterid: 16, parametername: "KVAT" },
      { parameterid: 17, parametername: "KVART" },
      { parameterid: 18, parametername: "PFT" },
      { parameterid: 19, parametername: "PFR" },
      { parameterid: 20, parametername: "PFY" },
      { parameterid: 21, parametername: "PFB" },
      { parameterid: 22, parametername: "KWR" },
      { parameterid: 23, parametername: "KWY" },
      { parameterid: 24, parametername: "KWB" },
      { parameterid: 25, parametername: "KVA_R" },
      { parameterid: 26, parametername: "KVA_Y" },
      { parameterid: 27, parametername: "KVA_B" },
      { parameterid: 28, parametername: "KVAR_R" },
      { parameterid: 29, parametername: "KVAR_Y" },
      { parameterid: 30, parametername: "KVAR_B" },
      { parameterid: 31, parametername: "KWD" },
      { parameterid: 32, parametername: "KVAD" },
      { parameterid: 33, parametername: "KWHTotal" },
      { parameterid: 34, parametername: "kWhImport" },
      { parameterid: 35, parametername: "KWHEXPORT" },
      { parameterid: 36, parametername: "kVAh" },
      { parameterid: 37, parametername: "kVArhTotal" },
      { parameterid: 38, parametername: "kVArhinductive" },
      { parameterid: 39, parametername: "KVARHCAPACITIVE" },
      { parameterid: 40, parametername: "V_THDAvg" },
      { parameterid: 41, parametername: "V_THDR" },
      { parameterid: 42, parametername: "V_THDY" },
      { parameterid: 43, parametername: "V_THDB" },
      { parameterid: 44, parametername: "I_THDAvg" },
      { parameterid: 45, parametername: "I_THDR" },
      { parameterid: 46, parametername: "I_THDY" },
      { parameterid: 47, parametername: "I_THDB" }
    ];
  
    // Map selected meter IDs to their meter names
    const meters = selectedMeterIds?.map((id) => {
      const meter =
        sectionId === 1
          ? nsGetFlowConverterList?.find((meter) => meter.meterid === id)?.metername
          : getFlowSteamGroupMeterList?.find((meter) => meter.meterid === id)?.metername;
  
      return meter || "";
    });
  
    // Initialize the result array
    const allmeters = [];
  
    // Loop through each meter
    meters?.forEach((meter) => {
      // Check if the selected values contain any of the parameter names
      parameterList.forEach(({ parametername }) => {
        if (selectedValues.includes(parametername)) {
          allmeters.push(`${meter}-${parametername}`);
        }
      });
    });
  
    // Output the result
    // //console.log(allmeters);
  
    return allmeters;
  };
  

  useEffect(() => {
    document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);


  const today = dayjs();
  const startOfWeek = dayjs().startOf("week").startOf("day"); // Sunday 12:00 AM
  const endOfWeek = dayjs().endOf("week").startOf("day");     // Saturday 12:00 AM
  
  const startOfLastWeek = dayjs().subtract(1, "week").startOf("week").startOf("day"); 
  const endOfLastWeek = dayjs().subtract(1, "week").endOf("week").startOf("day");     
  
  const startOfMonth = dayjs().startOf("month").startOf("day");     
  const endOfMonth = dayjs().endOf("month").startOf("day");        
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month").startOf("day");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month").startOf("day");
  
  const rangePresets = [
        { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day").startOf("day"), today.startOf("day")] },
  ];
  
       const handleDateChange = (value) => {
    // if (!value) return;
    // const diff = value[1]?.diff(value[0], "day");

    // if (diff > MAX_DAYS) {
    //   alert("Date range cannot exceed 90 days");
    //   return;
    // }

    if (value) {
      // const fromDate = value[0];
      // const toDate = value[1];
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
      if(!fromDate&& !toDate){
        setDatesError('Please select a date range');
      }else{
        setDatesError(null)
      }

      // //console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
      onChangeFromDate(fromDate);
      onChangeToDate(toDate);
    } else {
      setDatesError('Please select a date range');
    }
  };
  //console.log(loadings)
  //console.log(loading)
  //console.log(rawData)
  return (  
    <div
      className={` rounded-md p-4 w-auto dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
       <div className="flex justify-between items-center px-2 pb-0">
        <div className="text-3xl">
          <h4 className={`text-center  mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>RAW DATA</h4>
        </div>
       
          <div className=" gap-2 flex justify-end mr-2">
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
            <ExportToExcel
            disable={rawData && rawData?.length === 0}
            size="large"
              report={rawData}
              meters={selectedHeader}
              excelFromDate={excelFromDate}
              excelToDate={excelToDate}
              parameter={selectedValues?.length === 2}
            />
          </div>
      </div>
      {!loadings && !loading && rawData.length>0&& (  
        <div className={`m-2`}>
         
          <TableComponent 
            report={report} 
            meters={selectedHeader}
            data={rawData} 
            parameter={selectedValues.length === 2}
          />
        </div>
      ) 
      
    }
      { loading&&loadings&& (
        <>
          <Skeleton active paragraph={{ rows: 6 }} />
          {/* <div className={`${isdarkMode? '':''}`}>
           <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
          </div> */}
        </>
      )}
      { !loadings&&!loading && rawData.length==0&& (
        <>
          {/* <Skeleton active paragraph={{ rows: 6 }} /> */}
          <div className={`${isdarkMode? '':''}`}>
           <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
          </div>
        </>
      )}

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
        
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="parameterid"
            nameKey="parametername"
            valueKey="parameterid"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32  text-left"> Date:</label>
            <RangePicker
      value={value}
      onChange={handleDateChange}
      popupClassName="custom-picker"
      presets={rangePresets}
      format="YYYY-MM-DD HH:mm:ss"
      showTime={{ format: "HH:mm:ss" }}
      className={`w-80 ml-0 shadow-lg rounded-3xl  ${
        isdarkMode
          ? "customRangePicker-dark  text-white"
          : "customRangePicker-light text-black"
      }`}
      panelRender={(originalPanel) => {
        if (!showCalendar) {
          return (
            <div
              className={`${
                isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
              } flex flex-col gap-1 p-2 w-44 rounded`}
            >
              {rangePresets.map((preset) => (
                <div
                  key={preset.label}
                  onClick={() => handleDateChange(preset.value)}
                  className={`cursor-pointer px-2 py-1 rounded ${
                    isdarkMode
                      ? "text-white hover:bg-gray-700"
                      : "text-black hover:bg-gray-200"
                  }`}
                >
                  {preset.label}
                </div>
              ))}
              <button
                onClick={() => setShowCalendar(true)}
                className={`mt-2 px-2 py-1 rounded  border text-center ${
                  isdarkMode
                    ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                    : "bg-white border-black text-black hover:bg-gray-200"
                }`}
              >
                Custom Dates
              </button>
            </div>
          );
        }
        return originalPanel;
      }}
      onOpenChange={(open) => {
        if (!open) setShowCalendar(false);
      }}
    />
            
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {datesError}
          </small>
          
        </div>
        <div className="flex justify-center mt-4">
                      <Button
                        type= {isdarkMode? "":'primary'}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Search
                      </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
          .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default RawDataElectrical;
